import React from "react";
import { Box, Typography, Grid, Divider } from "@mui/material";
import { Icon } from "@iconify/react";
import { Link, useLocation } from "react-router-dom";


function ToolList({ categorizedTools }) {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <Box sx={{ padding: 4 }}>
      {/* Section Header */}
      <Typography
        variant="h3"
        fontWeight="bold"
        textAlign="center"
        sx={{ mb: 4, color: "#000" }}
      >
        {isHomePage ? "Free Tools" : "Other Free Tools"}
      </Typography>

      <Divider sx={{ marginBottom:'5rem' }} />

      {/* Grid Layout for Tools */}
      <Grid container spacing={4}>
        <Box sx={{ px: 3 }}>
          {Object.entries(categorizedTools).map(([sectionTitle, tools]) => (
            <Box key={sectionTitle} sx={{ mb: 5 }}>
              <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: "#333", pl:2 }}>
                {sectionTitle}
              </Typography>
              <Grid container spacing={1}>
                {tools.map((tool, index) => (
                  <Grid item xs={12} sm={6} md={6} key={index}>
                    <Box
                      component={Link}
                      to={tool.route}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        textDecoration: "none",
                        padding: "20px",
                        borderRadius: "12px",
                        backgroundColor: "#fff",
                        transition: "all 0.3s ease-in-out",
                        "&:hover": { boxShadow: "0 6px 14px rgba(0, 0, 0, 0.2)" },
                      }}
                    >
                      <Icon icon={tool.icon} width={45} height={45} style={{ marginRight: "16px", color: "rgb(0, 145, 70)" }} />
                      <Box>
                        <Typography variant="h6" fontWeight="bold" sx={{ color: "#000" }}>
                          {tool.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {tool.description}.
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </Box>
      </Grid>
    </Box>
  );
}

export default ToolList;
